import { observer } from 'mobx-react';
// @ts-ignore
import * as Validator from 'validatorjs';
import React, { useEffect, useMemo } from 'react';
import { toJS } from 'mobx';

import { Input } from '@gamesb42/ui-kit';
import { Title3 } from '../Typography';
import TextInput from '../TextInput';
import { about } from './index';
import styles from './styles.module.scss';

const AccountUsd = observer(() => {
  // Находим USD банковские реквизиты
  const usdBank = about.values.bank_details.find(
    (item) => item.currency === 'USD',
  );

  // Правила валидации для USD счета
  const validationRules = {
    bank_name: 'required',
    swift: 'required|regex:/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/',
    account: 'required',
  };

  const validation = useMemo(
    () =>
      new Validator(toJS(usdBank), validationRules, {
        required: 'This field is required',
        regex: 'Invalid SWIFT code format',
      }),
    [usdBank?.bank_name, usdBank?.swift, usdBank?.account],
  );

  const isValid = validation.passes();

  useEffect(() => {
    // Определяем номер шага: если только USD валюта - шаг 5, иначе - шаг 6
    const step =
      about.currency.length === 1 && about.currency[0] === 'usd' ? 5 : 6;
    about.isStepIsValid[step] = isValid;
  }, [isValid, about.currency]);

  // Если нет USD банка, не показываем ничего
  if (!usdBank) {
    return null;
  }

  return (
    <>
      <div style={{ marginBottom: '20px' }}>
        <Title3 className={styles.subTitle}>Your USD Bank Account</Title3>
      </div>

      <TextInput
        onChange={(e) => {
          usdBank.bank_name = e;
        }}
        label="Bank name*"
        dataTest="bankName"
        className={styles.textField}
        value={usdBank.bank_name || ''}
        error={validation.errors.first('bank_name')}
      />

      <TextInput
        onChange={(e) => {
          usdBank.swift = e;
        }}
        label="SWIFT code*"
        dataTest="swiftCode"
        className={styles.textField}
        value={usdBank.swift || ''}
        error={validation.errors.first('swift')}
      />

      <TextInput
        onChange={(e) => {
          usdBank.account = e;
        }}
        label="IBAN or account number*"
        dataTest="accountNumber"
        className={styles.textField}
        value={usdBank.account || ''}
        error={validation.errors.first('account')}
      />

      <TextInput
        onChange={(e) => {
          usdBank.bank_address = e;
        }}
        label="Bank address"
        dataTest="bankAddress"
        className={styles.textField}
        value={usdBank.bank_address || ''}
      />

      <TextInput
        onChange={(e) => {
          usdBank.correspondent_bank_name = e;
        }}
        label="Correspondent bank"
        dataTest="correspondentBank"
        className={styles.textField}
        value={usdBank.correspondent_bank_name || ''}
      />

      <TextInput
        onChange={(e) => {
          usdBank.correspondent_swift = e;
        }}
        label="Correspondent SWIFT code"
        dataTest="correspondentSwift"
        className={styles.textField}
        value={usdBank.correspondent_swift || ''}
      />

      <TextInput
        onChange={(e) => {
          usdBank.correspondent_account = e;
        }}
        label="Correspondent IBAN or account number"
        dataTest="correspondentAccount"
        className={styles.textField}
        value={usdBank.correspondent_account || ''}
      />

      <Input.TextArea
        style={{ height: '100px' }}
        label="Special instructions"
        maxLength={200}
        value={usdBank.special_instructions || ''}
        onChange={(e) => {
          usdBank.special_instructions = e.target.value;
        }}
      />
    </>
  );
});

export default AccountUsd;
